<template>
  <div>
    <builderall-loader :loading="loadingAll" class="ba-card">
      <template>
        <div v-show="steps.tagStep" class="container">
          <!-- Tag step -->
          <div v-show="steps.tagStep" class="row">
            <div class="col-12">
              <h1 class="text-center">{{ $t("ct-register-your-tags") }}</h1>
              <h4 class="text-center">{{ $t("ct-register-your-tags-desc") }}</h4>
            </div>

            <div class="body-container w-100">
              <div class="container-accordion-form">
                <template v-if="
                  groups.length === 1 &&
                  groups.find((group) => group.name === 'default')
                ">
                  <tags-item-component :group="groups.find((group) => group.name === 'default')"
                    :tags="tags"></tags-item-component>
                </template>

                <template v-else>
                  <div :class="{ 'pb-0': group.id !== '0' }" class="card">
                    <div class="row">
                      <label class="col-sm-2 col-form-label" for="tag-group">{{
                        $t("ct-group-tags-label")
                      }}</label>
                      <div class="col-sm-7">
                        <select id="tag-group" v-model="group.id" class="form-control">
                          <option disabled selected value="0">
                            {{ $t("ct-select-group-tags") }}
                          </option>
                          <option v-for="(group, index) in groups" v-bind:key="index" :value="group.id">
                            {{ group.name }}
                          </option>
                        </select>
                      </div>

                      <div class="col-sm-3">
                        <router-link :to="{ name: 'Tags' }" class="btn btn-primary sb-text float-right px-3 py-2">
                          {{ $t("ct-tags-manager") }}
                        </router-link>
                      </div>
                    </div>
                  </div>
                  <tags-item-component v-if="getGroup()" :group="getGroup()" :tags="tags"
                    custom_class="card"></tags-item-component>
                </template>
              </div>
            </div>

            <div class="w-100" style="padding-top: 50px; padding-bottom: 50px">
              <button class="btn btn-primary btn-bigger sb-text float-right" @click.prevent="goto('smart')">
                {{ $t("ct-selecionar-template") }}
              </button>
            </div>
          </div>
        </div>

        <template v-if="this.steps.templateStep">
          <div class='ba-flex ba-jc-sb ba-ai-center ba-w-100'>
            <span class='ba-title ba-h-100 ba-ai-center'>{{ $t('ct-new-website-link') }}</span>
            <div class='ba-box-items ba-flex ba-gp-1'>
              <SearchInput @search="searchTemplate" :config="config" />
              <button
                type="button"
                data-ba-i="ai-html-upload"
                class="ba-btn ba-md ai-html-upload-btn"
                @click="openAiHtmlUpload"
              >
                <img height="22" style="filter: brightness(0) invert(1);" src="/static/images/icons/ai-html.svg" alt="Create Website">
                {{ $t('ct-ai-html-upload') }}
              </button>
            </div>
          </div>
          <br>
          <hr class="ba-hr-row">
          <br>
          <div class="ba-grid ba-w-100">
            <div class="ba-flex ba-ai-end ba-jc-se ba-gp-1 ba-mg-b-1" v-if="!categoryFilterURL">
              <div class="ba-grid ba-w-100">
                <label class="ba-custom-label" for="template_type">{{ $t('ct-template-website-type') }}</label>
                <select id="template_type" v-model="template_type" class="ba-select ba-md" name="template_type"
                  @change="filterTemplates()">
                  <option value="all">{{ $t('ct-template-all') }}</option>
                  <option value="full_website">{{ $t('ct-template-full-website') }}
                  </option>
                  <option value="full_funnel">{{ $t('ct-template-full-funnel') }}
                  </option>
                </select>
              </div>
              <div class="ba-grid ba-w-100" v-if="template_type === 'full_funnel'">
                <label class="ba-custom-label" for="type2">{{ $t('ct-template-type') }}</label>
                <select id="type2" v-model="type2" class="ba-select ba-md" name="type2" @change="filterTemplates()">
                  <option value="all">{{ $t('ct-template-all') }}</option>
                  <option v-for="type2 in all_type2" :key="type2.id" :value="type2.value">
                    {{ type2.name }}
                  </option>
                </select>
              </div>
              <div class="ba-grid ba-w-100">
                <label class="ba-custom-label" for="type1">{{ $t('ct-template-industry') }}</label>
                <select id="type1" v-model="type1" class="ba-select ba-md" name="type1" @change="filterTemplates()">
                  <option value="all">{{ $t('ct-template-all') }}</option>
                  <option v-if="exclusiveTemplates" value="exclusive">{{ $t('ct-template-exclusive') }}
                  </option>
                  <template v-for="type1 in all_type1">
                    <option v-if="type1.show" :key="type1.id" :value="type1.value">{{ type1.name }}</option>
                  </template>
                </select>
              </div>
              <div class="ba-flex ba-gp-06 ba-ai-center custom-checkbox">
                <input type="checkbox" v-model="showPremiumTemplates" id="premium-templates"
                  @input="showPremiumTemplates = !showPremiumTemplates; filterTemplates()">
                <i class="svg-icon svgi-crown"></i>
                <label for="premium-templates" v-text="$t('ct-premium')"></label>
              </div>
            </div>

            <!-- Tab panes -->
            <div class="custom-container">
              <div v-if="!categoryFilterURL" id="category-all"
                :class="{ active: categorySelected === 'all' || filtered }">
                <div class="ba-flex ba-gp-1 ba-ai-baseline ba-jc-center ba-f-wrap">
                  <!-- <template v-if="blank_template && this.type1 === 'all' && this.type2 === 'all'">
                    <transition enter-active-class="animated fadeInUp" leave-active-class="animated fadeOut">
                      <box-template
                        v-show="String(categorySelected) === 'all' && ![61, 62].includes(parseInt(blank_template.category_id))"
                        :key="blank_template.id" :newTemplateSelected="newTemplateSelected" :template="blank_template"
                        @selectTemplate="selectTemplate" @selectedTemplate="selectedTemplate"></box-template>
                    </transition>
                  </template> -->
                  <template v-for="(template, index) in newAllTemplates">
                    <transition enter-active-class="animated fadeInUp" leave-active-class="animated fadeOut">
                      <box-template :key="template.id" :newTemplateSelected="newTemplateSelected" :template="template"
                        :isPremiumUser="isPremiumUser" :showPremium="showPremiumTemplates"
                        @selectTemplate="selectTemplate" @selectedTemplate="selectedTemplate"></box-template>
                    </transition>
                  </template>
                  <builderall-empty-image v-if="isEmptyTemplatesList"></builderall-empty-image>
                </div>
              </div>
              <template v-if="categoryFilterURL">
                <div v-for="(category, index) in all_categories" :id="'category-' + category.id" :key="index"
                  :aria-labelledby="'category-' + category.id" :class="{
                    active: categoryFilterURL && categoryFilterURL == category.id,
                  }">
                  <div>
                    <template v-for="template in category.templates">
                      <transition enter-active-class="animated fadeInUp" leave-active-class="animated fadeOut">
                        <box-template v-if="String(categorySelected) === String(category.id) || filtered"
                          :key="template.id" :newTemplateSelected="newTemplateSelected" :template="template"
                          @selectTemplate="selectTemplate" @selectedTemplate="selectedTemplate"></box-template>
                      </transition>
                    </template>
                  </div>
                </div>
              </template>
            </div>
          </div>
        </template>

        <div v-else-if="steps.smartTemplate" class="container content-smart-templates">
          <div class="row">
            <div class="col-12">
              <h1 class="text-center">
                {{ $t("ct-select-template-your-site") }}
              </h1>
              <h4 class="text-center">
                {{ $t("ct-select-template-your-site-help") }}
              </h4>
            </div>

            <div class="col-12">
              <div class="container">
                <div class="content-smart-templates-list">
                  <template v-for="template in all_templates">
                    <transition enter-active-class="animated fadeInUp" leave-active-class="animated fadeOut">
                      <box-template :key="template.id" :newTemplateSelected="newTemplateSelected" :template="template"
                        @selectTemplate="selectTemplate" @selectedTemplate="selectedTemplate"></box-template>
                    </transition>
                  </template>
                </div>
              </div>
            </div>
          </div>
        </div>

        <SectionHelpTemplate v-show="!this.steps.templateStep && !this.steps.smartTemplate" />
      </template>

      <AiBusinessTemplatePopup
        ref="ai-generate-website"
        :template="selectedTemplateData"
        @save="saveWebsite"
      />

      <sweet-modal ref="confirm-template" width="1000">
        <section class="blank-template-section">
          <div class="blank-animation">
            <img src="/static/images/firstWebsite/builder_animation_v3.gif" alt="Blank Template Animation">
          </div>
          <div class="blank-separator"></div>
          <div class="blank-template-content">
            <h2>{{ $t("ct-blank-template") }}</h2>
            <h1>{{ $t("ct-build-it-from-scratch") }}</h1>
            <p>{{ $t('ct-blank-modal-subheadline') }}</p>
            <ul>
              <li>
                <img src="/static/images/firstWebsite/take.svg" alt="Blank Template 1">
                <p>{{ $t('ct-blank-template-step-1') }}</p>
              </li>
              <li>
                <img src="/static/images/firstWebsite/ai.svg" alt="Blank Template 2">
                <p>{{ $t('ct-blank-template-step-2') }}</p>
              </li>
              <li>
                <img src="/static/images/firstWebsite/magic.svg" alt="Blank Template 3">
                <p>{{ $t('ct-blank-template-step-3') }}</p>
              </li>
              <li>
                <img src="/static/images/firstWebsite/save.svg" alt="Blank Template 3">
                <p>{{ $t('ct-blank-template-step-4') }}</p>
              </li>
            </ul>
            <div class="ba-flex ba-jc-fe" style="margin-top: 30px;">
              <button class="btn btn-outline-dark" @click.prevent="$refs['confirm-template'].close()">
                {{ $t("ct-pick-a-template-instead") }}
              </button>
              <button class="btn btn-primary" @click.prevent="saveWebsite">
                {{ $t("ct-start-building") }}
              </button>
              </div>
            </div>
        </section>
      </sweet-modal>
    </builderall-loader>

    <div class="ba-flex ba-gp-06 ba-ai-center ba-w-100"
      :class="`smart-templates ${smartTemplateInfo ? 'expanded' : ''}`" v-if="this.steps.templateStep"
      @click.stop="smartTemplateInfo = true">
        <builderall-icon code='info' class="ba-color-blue1" />
      <div class="ba-grid">
        <div class="ba-flex ba-jc-sb">
          <span class="smart-templates-title">
            {{ $t('ct-smart-templates') }}
          </span>
          <button class='ba-btn ba-btn-close ba-sm ba-rounded' v-if="smartTemplateInfo"
            @click.stop="smartTemplateInfo = false">
            <builderall-icon code='64f7' />
          </button>
        </div>
        <div v-if="smartTemplateInfo">
          <p class="smart-templates-subtitle">{{ $t('ct-meet-smart-templates') }}</p>
        </div>
        <div v-if="smartTemplateInfo" class="ba-flex ba-jc-fe">
          <router-link :to="{ name: 'CreateWebsite', query: { step: 'tag' } }" class="ba-btn ba-md ba-blue">
            {{ $t('ct-goto-smart-templates') }}
          </router-link>
        </div>
      </div>
    </div>
    <ai-html-upload-popup ref="aiHtmlUploadPopup" @success="onAiHtmlUploadSuccess" />

  </div>
</template>

<script>
import {
  getAll as getTemplates,
  getByFlag,
  getExclusive,
} from "../../js/services/editor/template";
import {
  getGroups,
  getTags,
  storeUserTags,
} from "../../js/services/editor/autotag";
import axios from "axios";

import { SweetModal } from "sweet-modal-vue";
import { transferDuplicateTemplate } from "../../js/services/editor/website";

import TagsItemComponent from "./components/TagsItem";
import BoxTemplate from "./BoxTemplate";
import SectionHelpTemplate from "./SectionHelpTemplate";
import SearchInput from "../general/SearchInput.vue";
import AiBusinessTemplatePopup from "./components/AiBusinessTemplatePopup.vue";
import AiHtmlUploadPopup from "./components/AiHtmlUploadPopup.vue";

// Slug em `template.url` que identifica o template em branco (independe de idioma / id).
const BLANK_TEMPLATE_URL_SLUG = 'blank-template';

function isBlankTemplate(template) {
  return template.url === BLANK_TEMPLATE_URL_SLUG;
}

export default {
  data() {
    return {
      isPremiumUser: false,
      showPremiumTemplates: true,
      scrollEffect: false,
      categorySelected: "all",
      loading: false,
      loadingAll: false,
      groups: [],
      tags: [],
      firstWebsite: false,
      templateFlagType: "",
      categoryFilterURL: false,
      template_type: 'all',
      steps: {
        templateStep: false,
        tagStep: false,
        smartTemplate: false,
      },
      newTemplateSelected: "",
      selectedTemplateData: "",
      group: {
        id: "0",
        name: "",
      },
      exclusiveTemplates: false,
      exclusiveTemplatesArray: [],
      config: {
        search: "",
      },
      search_term: "",
      filtered: false,
      all_templates: [],
      all_templates_filtered: [],
      newAllTemplates: [],
      all_categories: [],
      all_type1: [],
      all_type2: [],
      type1: "all",
      type2: "all",
      blank_template: false,
      smartTemplateInfo: false,
      isEmptyTemplatesList: false
    };
  },
  components: {
    SweetModal,
    TagsItemComponent,
    BoxTemplate,
    SectionHelpTemplate,
    SearchInput,
    AiBusinessTemplatePopup,
    AiHtmlUploadPopup
  },
  watch: {
    $route: function (current, old) {
      try {
        this.changeStep(current.query.step);
      } catch (e) {
        console.error(e);
      }
    },
    all_templates_filtered(newValue, oldValue){
      this.showFilteredTemplates();
    },
  },
  computed: {
    officeUrl() {
      return typeof process.env.OFFICE_URL !== 'undefined' ? process.env.OFFICE_URL : "https://office.builderall.com"
    }
  },
  async created() {
    let step = "template";
    if (this.$route.query.step) {
      step = this.$route.query.step;
    }

    if (this.$route.query.category) {
      this.categoryFilterURL = this.$route.query.category;
      this.categorySelected = this.$route.query.category;
    } else {
      this.categoryFilterURL = false;
      this.categorySelected = "all";
    }

    this.changeStep(step);

    let vm = this;

    document.addEventListener("scroll", function (e) {
      if (window.scrollY > 310) {
        vm.scrollEffect = true;
      } else {
        vm.scrollEffect = false;
      }
    });
  },

  mounted() {
    const email = localStorage.getItem("email");
    if(email){
      fetch(`${this.officeUrl}/br/office/user/info/${email}`)
        .then(response => response.json())
        .then(response => {
          if (response.status == "success") {
            // @Thais Andreu 13-03-26 E o Pedro quer que os premium templates estejam disponíveis de graça pra o 14 days trial.
            const premiumPlans = ['premium-plus-plan', 'wp-premium-plus-plan', 'premium-plus-plan-trial', 'test-usd', 'test-brl', 'test-eur'];
            const specialWpPlans = ['special-premium-wp', 'special-funnel-club-wp'];
            if (
              premiumPlans.includes(response.data.active_plan.slug) ||
              (specialWpPlans.includes(response.data.active_plan.slug) && response.data.created > '2024-12-12 00:00:00')
            ) {
              this.isPremiumUser = true;
            }
          }
        });
    }

    this.$nextTick(() => {
      if (
        ["template", "website", "landing_page", "personal_branding"].includes(
          this.$route.query.step
        ) &&
        !this.categoryFilterURL
      ) {
        document.getElementById("app").classList.add("container-template-fixed");
      }

      // this.blank_template = this.all_templates.find(template => template.category_id === 32);
    });

    const builds = {
      'startup-build': 90, // Business, Marketing
      'course-creator-build': 87, // Courses & Webinar
      'freelancer-build': 92, // Agency
      'agency-build': 92, // Agency
      'health-and-wellness-build': 86, // Health & Wellness
      'real-estate-business-build': 66, // Real Estate
      'the-enterprise-build': 85, // Professional Services
      'the-creative-build': 92, // Agency
      'the-expert-build': 90, // Business, Marketing
    };

    const buildSlug = localStorage.getItem('build_slug');
    if(buildSlug) {
      this.type1 = builds[buildSlug] || 'all';
    }

    if (this.$route.query['template-type']) {
      this.template_type = this.$route.query['template-type'];
    }

    if (this.$route.query['industry']) {
      this.type1 = this.$route.query['industry'];
    }

    if (this.$route.query['page-type']) {
      this.type2 = this.$route.query['page-type'];
    }
  },

  beforeDestroy() {
    document.getElementById("app").classList.remove("container-template-fixed");
  },

  methods: {
    openAiHtmlUpload() {
      this.$refs.aiHtmlUploadPopup.open();
    },
    onAiHtmlUploadSuccess({ website, isCreation } = {}) {
      // New uploads open the editor. Replacing HTML on an existing site stays on the list.
      if (isCreation && website && website.encrypted_id) {
        this.$router.push({
          name: 'AiEditor',
          params: { id: website.encrypted_id },
          query: { fromImport: '1' },
        });
        return;
      }

      this.$router.push({ name: 'Dashboard' }).then(() => {
        this.$root.$emit('dashboard-refresh-websites');
      });
    },
    showFilteredTemplates(){
      this.newAllTemplates = Array.isArray(this.all_templates_filtered) ? JSON.parse(JSON.stringify(this.all_templates_filtered)) : [];
    },

    sortedItems(data) {
      let newData = data.filter(t => ![61, 62].includes(parseInt(t.category_id)));

      // Ordena por título traduzido
      // newData.sort((a, b) => this.$t(a.title).localeCompare(this.$t(b.title)));

      newData = newData
        .filter(isBlankTemplate)
        .concat(newData.filter(template => !isBlankTemplate(template)));

      // Remove duplicados por id
      return newData.filter((t, i, arr) => i === arr.findIndex(x => x.id === t.id));
    },

    applyAllFilters() {
      const search = this.normalizeText(this.config.search || "");

      if (search) {
        // reset filters
        this.type1 = 'all';
        this.type2 = 'all';
        this.template_type = 'all';

        const base = JSON.parse(JSON.stringify(this.all_templates || []));

        let filtered = base.filter(t => {
          const title = this.normalizeText(this.$t(t.title));
          const desc = this.normalizeText(t.description || '');
          const keywords = (t.keywords || []).map(k =>
            this.normalizeText(k.name)
          );

          return (
            title.includes(search) ||
            desc.includes(search) ||
            keywords.some(k => k.includes(search))
          );
        });

        /**
         * Ordenação especial padrão
         */
         const priority = {
          full_website: 1,
          full_funnel: 2
        };

        filtered.sort((a, b) => {
          const typeDiff = (priority[a.template_type] || 99) - (priority[b.template_type] || 99);

          // Primeiro separa full_website / full_funnel
          if (typeDiff !== 0) return typeDiff;

          // Dentro de cada grupo: ordem alfabética
          return this.$t(a.title).localeCompare(this.$t(b.title));
        });

        this.filtered = true;
        this.search_term = search;
        this.all_templates_filtered = this.sortedItems(filtered);
        this.newAllTemplates = [...this.all_templates_filtered];
        this.isEmptyTemplatesList = this.all_templates_filtered.length === 0;

        this.$nextTick(() => {
          window.scrollTo({ top: 1, behavior: "smooth" });
        });

        return; // não aplica outros filtros
      }

      const industry = this.type1;
      const pageType = this.type2;
      const templateType = this.template_type;

      let base = (industry === 'exclusive')
        ? JSON.parse(JSON.stringify(this.exclusiveTemplatesArray || []))
        : JSON.parse(JSON.stringify(this.all_templates || []));

      let filtered = [...base];

      /**
       * TEMPLATE TYPE
       */
      if (templateType !== 'all') {
        filtered = filtered.filter(t => t.template_type === templateType);
      }

      /**
       * INDUSTRY
       */
      if (industry && industry !== 'all') {
        filtered = filtered.filter(t => String(t.category_id) === String(industry));
      }

      /**
       * PAGE TYPE
       * - ignorado se template_type === full_website
       * - aplicado apenas se page_type !== ALL
       */
      if (templateType !== 'full_website' && pageType && pageType !== 'all') {
        filtered = filtered.filter(t =>
          (t.template_categories || []).some(
            c => String(c.id) === String(pageType)
          )
        );
      }

      /**
       * Ordenação especial quando TEMPLATE_TYPE = ALL
       */
      if (templateType === 'all') {
        filtered = this.orderByTemplateTypeAndTitle(filtered);
      }

      // Ordenação alfabética
      if (templateType != 'all' && (industry != 'all' || pageType != 'all')) {
        filtered.sort((a, b) => this.$t(a.title).localeCompare(this.$t(b.title)));
      }

      this.filtered = false;
      this.search_term = "";
      this.all_templates_filtered = this.sortedItems(filtered);
      this.newAllTemplates = [...this.all_templates_filtered];
      this.isEmptyTemplatesList = this.all_templates_filtered.length === 0;

      this.$nextTick(() => {
        window.scrollTo({ top: 1, behavior: "smooth" });
      });
    },

    orderByTemplateTypeAndTitle(list) {
      const priority = {
        full_website: 1,
        full_funnel: 2
      };

      return list.sort((a, b) => {
        const aOrder = a.featured_templates && a.featured_templates.length > 0 ? a.featured_templates[0].display_order : null;
        const bOrder = b.featured_templates && b.featured_templates.length > 0 ? b.featured_templates[0].display_order : null;

        const aHasOrder = aOrder !== undefined && aOrder !== null;
        const bHasOrder = bOrder !== undefined && bOrder !== null;

        /**
         * 🔥 PRIORIDADE 1: display_order
         */
        if (aHasOrder && bHasOrder) {
          if (aOrder !== bOrder) return aOrder - bOrder;
        }

        // Quem tem display_order vem primeiro
        if (aHasOrder) return -1;
        if (bHasOrder) return 1;

        /**
         * 🔥 PRIORIDADE 2: template_type
         */
        const typeDiff =
          (priority[a.template_type] || 99) -
          (priority[b.template_type] || 99);

        if (typeDiff !== 0) return typeDiff;

        /**
         * 🔥 PRIORIDADE 3: título
         */
        return this.$t(a.title).localeCompare(this.$t(b.title));
      });
    },

    normalizeText(text = "") {
      return text
        .trim()
        .toLowerCase()
        .normalize("NFD")
        .replace(/[\u0300-\u036f]/g, "");
    },

    filterTemplates() {
      this.config.search = "";
      this.applyAllFilters();
    },

    searchTemplate() {
      this.applyAllFilters();
    },

    clearSearch() {
      this.config.search = "";
      this.applyAllFilters();
    },

    getGroup() {
      if (this.groups.length > 1) {
        return this.groups.find((g) => g.id === this.group.id);
      } else {
        return this.groups.find((group) => group.name === "default");
      }
    },

    getUserGroups() {
      let vm = this;
      this.loadingAll = true;

      getTags().then((res) => {
        vm.tags = res.data;
      });
      getGroups().then((res) => {
        vm.groups = res.data;
        vm.loadingAll = false;
      });
    },

    changeStep(step) {
      this.steps.templateStep = false;
      this.steps.tagStep = false;
      this.steps.smartTemplate = false;

      switch (step) {
        case "website":
          this.getTemplates("normal");
          this.templateFlagType = step;
          this.steps.templateStep = true;
          break;
        case "landing_page":
        case "personal_branding":
          this.getTemplatesFlag(step);
          this.steps.templateStep = true;
          this.templateFlagType = step;
          break;
        case "tag":
          this.getUserGroups();
          this.steps.tagStep = true;
          break;
        case "smart":
          this.getTemplates("smart");
          this.steps.smartTemplate = true;
          break;
        default:
          // template
          this.getTemplates("normal");
          this.steps.templateStep = true;
          break;
      }

      if (this.$route.query.category) {
        this.categoryFilterURL = this.$route.query.category;
        this.categorySelected = this.$route.query.category;
      } else {
        this.categoryFilterURL = false;
        this.categorySelected = "all";
      }

      if (
        ["template", "website", "landing_page", "personal_branding"].includes(
          this.$route.query.step
        ) &&
        !this.categoryFilterURL
      ) {
        document
          .getElementById("app")
          .classList.add("container-template-fixed");
      } else {
        document
          .getElementById("app")
          .classList.remove("container-template-fixed");
      }
    },

    goto(step) {
      if (step === "smart") {
        if (
          this.groups.length > 1 &&
          (this.group.id === "0" || this.group.id === "")
        ) {
          this.$snotify.error(this.$t("ct-select-tag-group"));
          return;
        }

        let group =
          this.groups.find((g) => g.id === this.group.id) ||
          this.groups.find((group) => group.name === "default");
        this.saveGroup(group);
      } else {
        this.$router.push({ name: "CreateWebsite", query: { step: step } });
      }
    },

    activeToggle() {
      let vm = this;
      setTimeout(() => {
        $("#templatesTabs a").on("click", function (e) {
          e.preventDefault();
          $(".tab-pane").hide();
          $(".tab-pane#" + $(this).attr("id")).show();
        });

        vm.loadingAll = false;
      }, 2000);
    },

    selectBlankTemplate() {
      let templateBlank = this.all_templates.find(template => template.category_id === 32);
      if (templateBlank) {
        this.selectTemplate(templateBlank.encrypted_id);
      }
    },

    selectTemplate(encrypted_id) {
      this.newTemplateSelected = encrypted_id;
      const templateBlank = this.all_templates.find(template => template.url == 'blank-template');

      if (this.newTemplateSelected) {
        if (templateBlank && (encrypted_id == templateBlank.encrypted_id)) {
          this.$refs["confirm-template"].open();
        } else {
          this.$refs["ai-generate-website"].open();
        }
      }
    },

    selectedTemplate(template) {
      this.selectedTemplateData = template;
    },

    getExclusiveTemplates() {
      var xhttp = new XMLHttpRequest();
      let vm = this;
      let officeUrl = typeof process.env.OFFICE_URL !== 'undefined' ? process.env.OFFICE_URL : "https://office.builderall.com"

      xhttp.open("GET", `${officeUrl}/us/office/login-status`, true);
      xhttp.setRequestHeader("X-Requested-With", "XMLHttpRequest");
      xhttp.onreadystatechange = function () {
        if (xhttp.readyState == 4 && xhttp.status == 200) {
          var res = JSON.parse(xhttp.responseText);

          if (typeof res !== "undefined" && typeof res.parent !== "undefined") {
            getExclusive(res.parent.aid).then(({ data }) => {
              if (data.templates.length > 0) {
                // vm.exclusiveTemplates = true;
                // vm.exclusiveTemplatesArray = data.templates;
              }
            });
          }
        }
      };
      xhttp.onerror = function () {
        vm.getAuth();
      };
      xhttp.withCredentials = true;
      xhttp.send();
    },

    async orderCategoryForFilter() {
      var allCategories = JSON.parse(JSON.stringify(this.all_categories));

      var mapCategories = (categories) => categories.map((category) => {
        return {
          id: category.id,
          value: category.id,
          show: category.show,
          name: this.$t(category.description)
        }
      });

      this.all_type1 = mapCategories(allCategories.filter(category => category.type === 'industry'));
      this.all_type2 = mapCategories(allCategories.filter(category => category.type === 'type'));

      this.filterTemplates();
    },

    async getTemplatesFlag(type) {
      this.loadingAll = true;

      this.all_templates = [];
      this.all_categories = [];

      await getByFlag(type)
        .then(async ({ data }) => {
          this.all_templates = data.templates;
          this.all_categories = data.categories;

          this.activeToggle();
          await this.orderCategoryForFilter();
        })
        .finally(() => {
          this.loadingAll = false;
        });
    },

    async getTemplates(type) {
      let vm = this;

      try {
        vm.getExclusiveTemplates();
      } catch (e) {
        console.log(e);
      }

      this.loadingAll = true;

      if (type === "normal") {
        this.all_templates = [];
        this.all_categories = [];

        await getTemplates("normal").then(async ({ data }) => {
          this.all_templates = data.templates;
          this.all_categories = data.categories;

          this.activeToggle();
          await this.orderCategoryForFilter();
        });
      } else if (type === "smart") {
        this.all_templates = [];
        this.all_categories = [];

        await getGroups().then(({ data }) => {
          this.tagGroups = data;
        });

        await getTemplates("smart").then(({ data }) => {
          this.all_templates = data.templates;
          this.all_categories = data.categories;

          vm.loadingAll = false;
        });
      } else {
        // Error escolhar um dos dois
      }
    },

    getName() {
      let name = "";
      if (this.$store.state.user.name) {
        name = String(this.$store.state.user.name);
      }
      return name;
    },

    saveGroup(group) {
      this.loadingAll = true;
      storeUserTags(group)
        .then(() => {
          this.changeStep("smart");
          this.$router.push({
            name: "CreateWebsite",
            query: { step: "smart" },
          });
        })
        .finally(() => this.loadingAll = false);
    },

    saveWebsite() {
      this.$refs["confirm-template"].close();
      this.loadingAll = true;
      transferDuplicateTemplate(
        { encrypted_id: this.newTemplateSelected },
        {
          title: this.$t("ct-my-website-title"),
          description: this.$t("ct-my-website-description"),
          type: this.steps.smartTemplate ? "smartTemplate" : "template",
          template_flag: this.templateFlagType,
          is_premium: this.selectedTemplateData.is_premium,
          original_template_id: this.selectedTemplateData.id,
          amount: this.selectedTemplateData.amount,
          group:
            this.steps.smartTemplate && this.groups.length === 1
              ? this.groups.find((group) => group.name === "default").id
              : this.group.id,
        }
      )
        .then(({ data }) => {
          if (data.success === false) {
            this.$snotify.warning(this.$t(data.error));
          } else {
            this.loadingAll = true;
            let home = data.website.layouts[0].pages.find(page => !!page.initial);
            let pageHome = home || data.website.layouts[0].pages[0];

            const route = this.$router.resolve({
              name: 'editor',
              params: { page_id: pageHome.encrypted_id }
            });

            window.open(route.href, '_blank');

            this.$router.push({ name: 'Dashboard' });

          }
        })
        .finally(() => (this.loadingAll = false));
    },
  },
};
</script>

<style lang="scss" scoped>
.custom-container {
  height: auto;
  overflow-y: hidden;
}

.custom-checkbox {
  color: #8d9eb5;
  background-color: #f4f6fb;
  border: none;
  border-radius: 6px;
  outline: none;
  font-weight: 600;
  padding: 12.8px 16px;
  font-size: 14px;
  height: 40px;

  label {
    margin: 0;
    text-wrap: nowrap;
    cursor: pointer;
  }
}

.smart-templates {
  padding: 16px;
  margin-top: 16px;
  border-radius: 8px 0px 0px 0px;
  opacity: 0px;
  background: #DAEDFF;
  cursor: pointer;
  width: fit-content;
  margin-left: auto;

  .expanded {
    width: 100%;
  }

  .smart-templates-title {
    font-size: 16px;
    font-weight: 700;
    line-height: 24px;
    text-align: left;
    color: #0072E1;

  }

  .smart-templates-subtitle {
    font-size: 14px;
    font-weight: 500;
    line-height: 21px;
    text-align: left;

  }
}

.ba-select{
  height: 40px;
  font-size: 14px;
  cursor: pointer;
}

.container-template-main {
  margin: 0 auto;

  @media (min-width: 1024px) {
    max-width: calc(100vw - 80px);
  }

  @media (min-width: 1680px) {
    max-width: 1600px;
  }

  .content-templates {
    margin-left: unset;
    padding-left: 15px;

    @media (min-width: 1024px) {
      margin-left: 280px;
    }

    @media (min-width: 1366px) {
      margin-left: 350px;
    }
  }
}

.first-website {
  .container-template-navbar-categories {
    //max-height: 200px;
    overflow: auto;
    margin: 15px;

    &::-webkit-scrollbar {
      width: 6px;
    }

    &::-webkit-scrollbar-track {
      background: #fff;
    }

    &::-webkit-scrollbar-thumb {
      background: darken(whitesmoke, 5%);
      border-radius: 6px;
    }

    &::-webkit-scrollbar-thumb:hover {
      background: darken(whitesmoke, 10%);
    }

    @media (min-width: 1024px) {
      margin: unset;
      width: 280px;


      &.position-fixed-baby-2 {
        position: fixed;
        top: 0;
        margin-top: 20px;
        max-height: calc(100vh - 50px);
      }

      float: left;
    }

    @media (min-width: 1366px) {
      width: 350px;
    }
  }

  .container-template-header {
    background: #e9edf2;
    transition: width 2s;
    width: 100%;
    height: 200px;

    display: flex;
    flex-direction: column;
    justify-content: flex-end;

    .container-template-header-content {
      h1 {
        margin-top: 20px;

        @media (min-width: 1024px) {
          margin-top: 0;
        }
      }
    }

    .container-template-header-content {
      max-width: 1600px;
      margin: 0 auto;

      display: flex;
      flex-direction: column;
      justify-content: flex-end;

      @media (min-width: 1024px) {
        max-width: 1000px;
      }

      @media (min-width: 1680px) {
        max-width: 1200px;
      }
    }

    @media (min-width: 768px) {
      left: 0;
      z-index: 1;
      box-shadow: 0 1px 2px transparent;
      border: 1px solid transparent;
      transition: box-shadow 1s ease-in-out;

      &.position-fixed-baby-2 {
        box-shadow: 0 1px 2px #26242424;
        border: 1px solid #dedede;
      }
    }

    @media (min-width: 1024px) {
      height: 270px;
    }
  }

  .content-templates .tab-content .tab-pane>div {
    display: flex;
    flex-wrap: wrap;
    gap: 16px;
    justify-content: center;
  }

  .content-smart-templates .content-smart-templates-list {
    display: flex;
    flex-wrap: wrap;
    gap: 16px;
    justify-content: center;
  }
}

.container-dashboard {
  overflow: hidden;
}

.first-website {
  .first-row {
    margin-bottom: 150px;
  }

  h1 {
    text-align: left;
    font-family: Muli;
    font-size: 28px;
    letter-spacing: 0;
    color: #0080fc;
    opacity: 1;
    margin-top: 90px;
    margin-bottom: 30px;
    font-weight: 900;

    @media (min-width: 1024px) {
      font-size: 50px;
    }
  }

  h4 {
    text-align: left;
    font-family: Muli;
    font-size: 16px;
    letter-spacing: 0.54px;
    color: #434343;
    opacity: 1;
    margin-bottom: 25px;
    line-height: 1.5;

    @media (min-width: 1024px) {
      font: 18px/16px Muli;
      margin-bottom: 75px;
    }
  }

  .btn-bigger {
    width: 389px;
    height: 76px;
    background: #0f7bff 0% 0% no-repeat padding-box;
    border-radius: 8px;
    opacity: 1;
    font: 20px/27px Lato;
    letter-spacing: 0px;
    color: #ffffff;
    text-transform: capitalize;
  }

  .img-first-website {
    background-image: url("/static/images/firstWebsite/illustration+fundo.svg");
    display: block;
    height: 663px;
    width: 785px;
    background-position: unset;
    background-repeat: no-repeat;
    background-size: cover;
    position: absolute;
    top: -114.453125px;
    left: 50px;
  }

  .nav-tabs {
    background: #ffffff 0% 0% no-repeat padding-box;
    border: 1px solid #e3e8eb;
    opacity: 1;
    border-radius: 5px;
    //margin-bottom: 50px;
    overflow: hidden;

    .nav-item {
      width: 100%;

      label {
        margin-bottom: 0;
      }

      .form-group {
        margin-left: 15px;
        margin-right: 15px;
      }
    }

    a.active {
      background: #2690f7;
      opacity: 1;
      color: white !important;
      border-radius: 0;
    }

    a:hover:not(.active) {
      font-weight: bold;
    }
  }
}

.place-inputs {
  background-color: white;
  border: none;
  padding: 50px;
}

.container-accordion-form .card {
  border: none !important;
  padding: 50px;
}

.tags-separator {
  margin-bottom: 30px;
}

.form-control {
  background-color: #fafbfc;
  border-color: #e2e4e9;
}

.blank-template-section {
  display: flex;
  padding-top: 25px;
  .blank-animation {
    flex-basis: 390px;
    flex-shrink: 0;
    margin-left: -21px;
    img {
      border-radius: 16px;
      width: 100%;
    }
  }
  .blank-separator {
    flex-basis: 1px;
    background-color: #D3D7DB;
    margin: 0 16px;
  }
  .blank-template-content {
    padding: 20px;
    h2 {
      color: var(--Blue-primary, var(--Blue-primary, #0072E1));
      font-size: 16px;
      font-weight: 800;
      line-height: 17px;
      text-transform: uppercase;
    }
    h1 {
      color: var(--Blue-primary, var(--Blue-primary, #0072E1));
      font-size: 32px;
      font-weight: 800;
      line-height: 35px;
      margin: 6px 0;
    }
    p {
      color: var(--Neutral-Gray-Medium, #8D9EB5);
      font-size: 16px;
      font-weight: 500;
      line-height: normal;
    }
    ul {
      padding-inline-start: 0;
      margin: 0;
      li {
        display: flex;
        align-items: center;
        gap: 6px;
        margin-top: 18px;
        p {
          color: #4D4D4D;
          font-size: 16px;
          font-weight: 400;
          line-height: normal;
        }
      }
    }
  }
}
</style>


// WEBPACK FOOTER //
// src/components/dashboard/FirstWebsite.vue